export const examInfoTagList = [
  '감정평가사',
  '회계사',
  '변호사',
  '법무사',
  '세무사',
  '노무사',
  '관세사',
  '변리사',
  '의사',
  '약사',
  '한의사',
  '치과의사',
  '수의사',
  '기타고시',
  '공시',
  '기타',
]
